"use strict";

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.unscopables.flat-map");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

exports.__esModule = true;
exports.plugin = void 0;

var _util = require("../util");

var errors = {};
var styles = [{
  type: 'stylesheet',
  data: {
    href: 'https://cdn.jsdelivr.net/npm/prismjs@1/themes/prism.css'
  }
}];
var scripts = [{
  type: 'iife',
  data: {
    fn: function fn() {
      window.Prism = {
        manual: true
      };
    }
  }
}, {
  type: 'script',
  data: {
    src: 'https://cdn.jsdelivr.net/npm/prismjs@1/components/prism-core.min.js'
  }
}, // components will be added by paths relative to path of autoloader
{
  type: 'script',
  data: {
    src: 'https://cdn.jsdelivr.net/npm/prismjs@1/plugins/autoloader/prism-autoloader.min.js'
  }
}];

function initialize(Markmap, options) {
  Markmap.transformHtml.tap(function (mm, nodes) {
    var _window = window,
        Prism = _window.Prism;
    var langs = (0, _util.flatMap)(nodes, function (node) {
      return (0, _util.arrayFrom)(node.querySelectorAll('code[class*=language-]'));
    }).map(function (code) {
      var lang = code.className.match(/(?:^|\s)language-(\S+)|$/)[1];

      if (Prism.languages[lang]) {
        Prism.highlightElement(code);
      } else if (!errors[lang]) {
        return lang;
      }
    }).filter(Boolean);
    loadLanguagesAndRender(mm, langs);
  });
}

function loadLanguagesAndRender(_x, _x2) {
  return _loadLanguagesAndRender.apply(this, arguments);
}

function _loadLanguagesAndRender() {
  _loadLanguagesAndRender = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mm, langs) {
    var _window2, Prism;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (langs.length) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _window2 = window, Prism = _window2.Prism;
            _context.prev = 3;
            _context.next = 6;
            return new Promise(function (resolve, reject) {
              Prism.plugins.autoloader.loadLanguages(langs, resolve, reject);
            });

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](3);
            errors[_context.t0] = true;

          case 11:
            mm.setData();
            mm.fit();

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 8]]);
  }));
  return _loadLanguagesAndRender.apply(this, arguments);
}

var plugin = {
  styles: styles,
  scripts: scripts,
  initialize: initialize
};
exports.plugin = plugin;